import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-text-link',
  templateUrl: './text-link.component.html',
  styleUrls: ['./text-link.component.css']
})
export class TextLinkComponent {

  @Input() titulo = '';
  @Input() icone = null;
  @Input() disabled = false;
  @Output() click = new EventEmitter<void>();

  handleClick(event: MouseEvent) {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.click.emit();
  }

}
